// extracted by mini-css-extract-plugin
export default {"container":"aut_202OK","picture":"aut_pic_2JHSP","circle":"aut_cir_3GaZ9","withoutCircle":"aut_wit_d4NM4"};